import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from "../../configurations/firebaseConfig";
import { fetchUserInformation } from "./authAPI";
import { getRankColor } from "./rankColor";

// 사이드바 · 계정 메뉴 등 여러 곳에서 동시에 쓰므로 계정별로 한 번만 요청한다.
const rankRequests = new Map<string, Promise<number | null>>();

function fetchMyRank(uid: string): Promise<number | null> {
  let request = rankRequests.get(uid);
  if (request === undefined) {
    request = fetchUserInformation()
      .then((information) => information.rank)
      .catch(() => {
        // 실패한 요청은 캐시하지 않아 다음에 다시 시도한다
        rankRequests.delete(uid);
        return null;
      });
    rankRequests.set(uid, request);
  }
  return request;
}

// 로그인한 사용자의 랭킹 닉네임 색상. 랭킹이 없으면 undefined.
export function useMyRankColor(): string | undefined {
  const [color, setColor] = useState<string>();

  useEffect(() => {
    let isCancelled = false;
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      const uid = user?.providerData[0]?.uid;
      if (uid === undefined) {
        setColor(undefined);
        return;
      }
      fetchMyRank(uid).then((rank) => {
        if (isCancelled === false) setColor(getRankColor(rank));
      });
    });
    return () => {
      isCancelled = true;
      unsubscribe();
    };
  }, []);

  return color;
}
